var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',_vm._l((_vm.getItems),function(item,index){return _c('v-col',{key:index,attrs:{"cols":"12","md":"4"}},[_c('product-stock',{attrs:{"product":item.product,"in-stock":item.quantity,"minimum":item.minimum,"readonly":""}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }